import { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import AssigneeUI from '@/component/formManagement/fieldUI/AssigneeFieldUI';
import { useRecoilValue } from 'recoil';
import { getUserListByProjectAtom, userAtom } from '@/state/atom/userAtom';
import { getAssignList } from '@/component/ticketList/handler/TicketListHandler';
import { getProjectMemberList } from '@/component/ticketList/handler/HelpDeskTicketListHandler';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { PropTypes } from 'prop-types';

export default function OriginEmailAssignField({
    detailTicket,
    fieldListDefaultData,
    newAssignee,
    setNewAssignee,
    currentAssigneeUserData,
    setCurrentAssigneeUserData,
    isEdited,
    setIsEdited,
    isEditTicket,
    setIsEditTicket,
    isMe,
    setIsMe,
    newAssigneeData,
    setNewAssigneeData,
    isDisableEdit,
    triggerEnableBtnSaveTicket,
    setListFieldEdited,
    listFieldEdited,
    setFlagReset,
    flagReset,
}) {
    const currentUserDetail = useRecoilValue(userAtom);
    const [assignField, setAssignField] = useState(null);
    let userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const isGeneralUser = Utils.isGeneralUserWithoutGuest(currentUserDetail);
    const [assignList, setAssignList] = useState([]);

    const [onChangeEdit, setOnChangeEdit] = useState(false)
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    async function fetchData() {
        let personInChargeField = fieldListDefaultData.find(field => field.sysField === 'personInCharge');
        if (personInChargeField) {
            let sortUserList = await getProjectMemberList(userListRecoilValue);
            let assignListRes = getAssignList(sortUserList, currentUserDetail);
            setAssignList(assignListRes);
            setAssignField(personInChargeField);
        }
    }

    useEffect(() => {
        fetchData();
    }, [
        fieldListDefaultData,
    ]);

   let argsAll = {
       isMe,
       setIsMe,
       isDisableEdit,
       setFlagReset,
       flagReset
   };
   if (!assignField) return (<></>)
  
    return (
        <AssigneeUI
            setNewAssignee={setNewAssignee}
            setNewAssigneeData={setNewAssigneeData}
            setIsEdited={setIsEdited}

            setOnChangeEdit={setOnChangeEdit}
            onChangeEdit={onChangeEdit}

            assigneeUserData={currentAssigneeUserData}
            setCurrentAssigneeUserData={setCurrentAssigneeUserData}
            ticketDetail={detailTicket}
            isGeneralUser={isGeneralUser}
            isManager={isProjectManager} //isProjectManager
            isDisplayButtonEditTicket={true} // isDisplayButtonEditTicket()
            assignList={assignList}
            isHelpDesk={true}
            setListFieldEdited={setListFieldEdited}
            listFieldEdited={listFieldEdited}
            setIsEditTicket={setIsEditTicket}
            data={assignField}
            name={assignField.id}
            isShowIconCopyFieldId={false}
            isEmail={true}
            {...argsAll}
        />
    );
}

OriginEmailAssignField.propTypes = {
    setListFieldEdited: PropTypes.any,
    listFieldEdited: PropTypes.any,
    setFlagReset: PropTypes.any,
    flagReset: PropTypes.any
};
